import {
  useGetAllowedTokensParameterGroupQuery,
  useGetCustomerGroupParameterGroupQuery,
  useGetDomicileClassParameterGroupQuery,
  useGetProductGroupParameterGroupQuery,
  useGetSalesChannelParameterGroupQuery
} from 'Services/ProductManagement/Features/Parameter/parameterApi'
import { IS_WALTTI_SERVICE_ENVIRONMENT } from 'Util/constants'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const SELECTED_PARAMETER_KEY = 'selectedParameter'

function useParameterGroups() {
  const [searchParams, setSearchParams] = useSearchParams()

  const selectedParameterQueryParam = searchParams.get(SELECTED_PARAMETER_KEY) ?? undefined
  const [selectedParameterId, setSelectedParameterId] = useState(selectedParameterQueryParam)

  const {
    data: productGroupParameterGroup = null,
    refetch: fetchProductGroups,
    isLoading: productGroupParameterGroupLoading,
    isFetching: productGroupParameterGroupFetching
  } = useGetProductGroupParameterGroupQuery()

  const {
    data: customerGroupParameterGroup = null,
    refetch: fetchCustomerGroups,
    isLoading: customerGroupParameterGroupLoading,
    isFetching: customerGroupParameterGroupFetching
  } = useGetCustomerGroupParameterGroupQuery()

  const {
    data: salesChannelParameterGroup = null,
    refetch: fetchSalesChannels,
    isLoading: salesChannelParameterGroupLoading,
    isFetching: salesChannelParameterGroupFetching
  } = useGetSalesChannelParameterGroupQuery()

  const {
    data: domicileClassParameterGroup = null,
    refetch: fetchDomicileClasses,
    isLoading: domicileClassParameterGroupLoading,
    isFetching: domicileClassParameterGroupFetching
  } = useGetDomicileClassParameterGroupQuery(undefined, {
    skip: IS_WALTTI_SERVICE_ENVIRONMENT // Waltti does not use domicile classes
  })

  const {
    data: allowedTokensParameterGroup = null,
    refetch: fetchAllowedTokens,
    isLoading: allowedTokensParameterGroupLoading,
    isFetching: allowedTokensParameterGroupFetching
  } = useGetAllowedTokensParameterGroupQuery()

  useEffect(() => {
    if (selectedParameterId) {
      selectedParameterId && searchParams.set(SELECTED_PARAMETER_KEY, selectedParameterId)
      setSearchParams(searchParams)
    } else {
      searchParams.delete(SELECTED_PARAMETER_KEY)
      setSearchParams(searchParams)
    }
  }, [selectedParameterId])

  return {
    productGroupParameterGroup,
    isProductGroupParameterGroupLoading:
      productGroupParameterGroupLoading || productGroupParameterGroupFetching,
    customerGroupParameterGroup,
    isCustomerGroupParameterGroupLoading:
      customerGroupParameterGroupLoading || customerGroupParameterGroupFetching,
    salesChannelParameterGroup,
    isSalesChannelParameterGroupLoading:
      salesChannelParameterGroupLoading || salesChannelParameterGroupFetching,
    domicileClassParameterGroup,
    isDomicileClassParameterGroupLoading:
      domicileClassParameterGroupLoading || domicileClassParameterGroupFetching,
    allowedTokensParameterGroup,
    isAllowedTokensParameterGroupLoading:
      allowedTokensParameterGroupLoading || allowedTokensParameterGroupFetching,
    fetchProductGroups,
    fetchCustomerGroups,
    fetchSalesChannels,
    fetchDomicileClasses,
    fetchAllowedTokens,
    selectedParameterId,
    setSelectedParameterId
  }
}

export default useParameterGroups
